export const zIndices = {
  backgroundColor: -10,
  hide: -1,
  auto: 'auto',
  base: 0,
  carousel: 100,
  carouselButtons: 110,
  header: 1000,
  toast: 9999
}
